<template>

</template>

<script>
export default {
    name: "PaginationNoneLayout"
}
</script>

<style scoped>

</style>